var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_page",attrs:{"id":"app"}},[_c('HeaderComponent'),_c('TermsOfServiceComponent'),_c('FooterComponents',{staticClass:"m-t-200"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }